import React from 'react';
import {NotFoundBlock} from "../NotFoundBlock/NotFoundBlock";

export const NotFound = () => {
    return (
        <NotFoundBlock/>
    );
};

